<template>
<div class="registration-certificate-content">
    <div class="content">
        <el-table ref="multipleTable" border row-key="id" :data="tableData"  style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
                <div class="empty-div">
                    <img src="../../../../assets/noData.png" width="240" height="200" />
                    <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                    <div class="empty-rest" @click="reset">恢复默认</div>
                </div>
            </template>
            <el-table-column type="index" label="序号" fixed width="55">
            </el-table-column>
            <el-table-column prop="no" label="批准文号" min-width="180"></el-table-column>
            <el-table-column prop="name" label="注册证名称" min-width="100">
            </el-table-column>
            <el-table-column prop="effectDate" label="生效日期" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ parseTime(new Date(scope.row.effectDate), "{y}-{m}-{d}") }}
                </template>
            </el-table-column>
            <el-table-column prop="invalidDate" label="失效日期" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ parseTime(new Date(scope.row.invalidDate), "{y}-{m}-{d}") }}
                </template>
            </el-table-column>
            <el-table-column prop="manufacturerName" label="生产厂家" min-width="180"></el-table-column>
            <el-table-column prop="isDefault" label="是否默认" min-width="100">
                <template slot-scope="scope">
                    <span>{{ scope.row.id !== defaultId ? "否" : "是" }}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="showOperate" prop="operation" fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.id !== defaultId" type="text" v-preventReClick @click="handleDefault(scope.row)" class="margin-left20 color-blue">设置为默认</el-button>
                    <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-red">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {
    GetProductRegistCerts,
    RemoveProductRegistCerts,
} from "@/api";
import {
  WarehouseTypeOptions,
} from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin.js";
import MyUpload from "@/components/my-upload";

export default {
    mixins: [GetDataMixin],
    components: {
        MyUpload,
    },
    props: {
        filterIds:{
            type:Array,
            default:[]
        },
        defaultId:{
            type:[String,Number],
            default:''
        },
        showOperate:{
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
            WarehouseTypeOptions:WarehouseTypeOptions,
            // 查询条件
            query: {
                SourceType: 2,
                keyWord: "",
                pageSize: 10,
                pageIndex: 1,
            },
            // 列表数据
            tableData: [],
            // 列表总数
            total: 0,
            // 多选框数据
            ids: [],
            timer:null
        };
    },
    methods: {
        // 获取列表
        getData() {
            this.ids = this.filterIds
            this.query.ids = this.ids
            GetProductRegistCerts(this.query).then((res) => {
                this.tableData = res.returnData.data;
                this.tableData.forEach(item=>{
                    if(item.id == this.defaultId){
                        item.isDefault = true
                    }else{
                        item.isDefault = false
                    }
                })
                this.total = res.returnData.totalCount;
                this.$emit('certInfosData',this.tableData)
            });
        },
        // 改变当前页
        changePage(val) {
            this.$set(this.query, "pageIndex", val);
            this.getData();
        },
        handleSizeChange(val) {
            this.$set(this.query, "pageSize", val);
            this.getData();
        },

        // 删除
        handleDelete(row) {
            this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
                    type: "warning",
                })
                .then(() => {
                    this.$emit('delId',row.id )
                    this.$my_message(`删除成功`, "success");
                })
                .catch(() => {});
        },
        // 重置
        reset() {
            this.query.keyWord = "";
            this.$set(this.query, "pageIndex", 1);
            this.$set(this.query, "pageSize", 10);
            this.ids = []

            if (this.$refs.multipleTable) {
                this.$refs.multipleTable.clearSelection()
            }
            this.getData();
        },
        // 点击默认
        handleDefault(row){
            this.$emit('chooseDefaultId',row.id )
            this.$emit('certInfosData',this.tableData)
        }
    },
    mounted() {
        this.timer = setTimeout(() => {
            this.getData();
        }, 200);
    },
    destroyed() {
        if(this.timer){
            clearTimeout(this.timer);
            this.timer = null
        }
    },
};
</script>

<style lang="scss" scoped>
.registration-certificate-content{
    width: 100%;
    margin-top: 20px;
    margin-left: 18px;
    .pagination{
        margin-top: 16px;
    }
}
.manageRange {
    width: 100%;
    max-height: 120px;
    overflow-x: hidden;

    /deep/.el-select__tags {
        max-height: 120px !important;
    }
}

.oldProduction {}
.content{
    height: auto;
}
</style>
